<script>
/**
 * @file 课程详情
 */
import {publicOrderClasses} from '../__mock__/classes';

import Footer from './footer.vue';
import ForkissIcon from './forkiss-icon';
import mixin from './mixins_api';

export default {
    mixins: [mixin],
    components: {
        Footer,
        ForkissIcon
    },
    created() {
        this.fetchDetail();
    },
    methods: {
        fetchDetail() {
            // 根据 id 查课程详情
            let id = this.$route.params.id;
            if (id) {
                this.getCourseDetail(id).then(res => {
                    let result = res.result || {};
                    this.classesInfo = {...result};
                });
            }
        },
        goback() {
            this.$router.push({name: 'public-order'});
        },
        orderClass() {
            let {status, msg} = this.getOrderStatus(this.classesInfo);
            this.createOrder({
                course_id: this.$route.params.id,
                status: status
            }).then(res => {
                this.$root.$emit('showToast', msg);
                this.fetchDetail();
            });
        },
        viewAuthorDetail() {
            this.$router.push({
                name: 'author-detail',
                params: {
                    id: this.classesInfo.teacher_id,
                    refer_name: 'order-detail',
                    classId: this.$route.params.id
                }
            });
        }
    },
    data() {
        return {
            classesInfo: {}
        };
    }
}
</script>

<template lang="pug">
.forkiss-classes-detail-container
    .classes-box
        .back-btn(@click="goback", data-touch="true")
        .classes-card
            .classes-mask
                .classes-text-box
                    .name {{classesInfo.title}}
                    .en_name {{classesInfo.title_en}}
                    ForkissIcon.time(icon="forkiss-icon-time") {{classesInfo.start_time | date("YYYY-mm-dd HH:MM")}}
                    ForkissIcon.address(icon="forkiss-icon-address") {{classesInfo.room_name}}
                .classes-info
                    span.booked-count {{classesInfo.apply_num}}
                    span /
                    span {{classesInfo.capacity}}
                    span 人
    .detail-box
        .author-name {{classesInfo.teacher_name}}
        .author-en-name {{classesInfo.teacher_name_en}}
        .author-content
            .author-brife-box
               .author-brife {{classesInfo.teacher_desc}}
            img.author-img(:src="classesInfo.teacher_pic")
        a.link-name(@click="viewAuthorDetail", data-touch="true") 详细介绍
        hr.devide
        .classes-time 课程时长：{{classesInfo.long_time}}
        .classes-title 课程介绍
        .classes-detail-content(v-html="classesInfo.content")
    .order-btn(@click="orderClass", data-touch="true") {{statusText(classesInfo)}}
</template>

<style lang="less" scoped>
.forkiss-classes-detail-container {
    background: #FFF;
    font-size: .24rem;
    .classes-box {
        position: relative;
        text-align: center;
    }
    .back-btn {
        position: absolute;
        z-index: 22;
        top: .2rem;
        left: .2rem;
        width: .44rem;
        height: .44rem;
        background-image: url(../assets/back.svg);
        background-size: contain;
    }
    .classes-card {
        position: relative;
        height: 4.35rem;
        background: #2d2b28;
        background-image: url(../assets/detail-bg.png);
        background-position: center;
        background-size: cover;
        text-align: left;
    }

    .classes-mask {
        position: relative;
        padding: 0 .55rem;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, .6);
    }

    .classes-text-box {
        display: inline-block;
        vertical-align: top;
        margin-top: .92rem;
        color: #e2c19d;

        .name {
            font-size: .48rem;
        }
        .en_name {
            font-size: .2rem;
            margin-bottom: .2rem;
            color: #b2997d;
        }
        .time {
            color: #fff;
            font-size: .34rem;
        }
        .address {
            color: #fff;
            font-size: .34rem;
        }
    }
    .classes-info {
        position: absolute;
        bottom: .6rem;
        right: .54rem;
        color: #e2c19d;

        .booked-count {
            font-size: .34rem;
        }
    }

    .detail-box {
        padding: .6rem .28rem 1.64rem;
        color: #666;

        .author-name {
            font-size: .4rem;
            color: #a4805b;
        }

        .author-en-name {
            color: #a4805b;
            font-size: .24rem;
        }
        .author-brife-box {
            display: inline-block;
            vertical-align: middle;
            width: 4.68rem;
            margin-right: .2rem;
        }
        .author-brife {
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 3;
            -webkit-box-orient: vertical;
            line-height: 1.8;
        }
        .author-img {
            display: inline-block;
            vertical-align: middle;
            width: 1.98rem;
            height: 1.98rem;
            border: .06rem solid #edd3b7;
            border-radius: 50%;
            background: #f8ede1;
            background-image: url(../assets/detail-avatar.png);
            background-size: contain;
        }

        .link-name {
            color: #a4805b;
            margin-top: .24rem;

            &::after {
                content: "";
                display: inline-block;
                width: .22rem;
                height: .16rem;
                background-image: url(../assets/double-arrow.png);
                background-repeat: no-repeat;
                background-size: contain;
                margin-left: .08rem;
            }
        }
        .devide {
            border: 1px solid #eee;
            margin: .3rem 0;
        }
        .classes-time,
        .classes-title {
            color: #333;
            font-size: .28rem;

            &::before {
                content: "";
                display: inline-block;
                width: .06rem;
                height: .28rem;
                background: #c3a07b;
                margin-right: .2rem;
            }
        }

        .classes-time {
            margin-bottom: .2rem;
        }

        .classes-detail-content {
            margin-top: .1rem;
            line-height: 1.8;

            p {
                text-indent: .48rem;
                margin: 0;
            }
        }

    }
    .order-btn {
        position: fixed;
        bottom: 0;
        width: 100%;
        height: 1.1rem;
        line-height: 1.1rem;
        text-align: center;
        background: #c3a07b;
        color: #FFF;
        font-size: .32rem;

        &.disabled {
            background: #e2c19d;
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/components/order-detail.vue